import {
} from "@material-ui/core";
import {
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { resetHealthcareOrder } from "../redux/healthcareOrderActions";
import { resetShippingCost } from "../redux/shippingCostRedux";
import { createUserSocket } from "../utils/userSocket";
import { clearCart } from "../redux/healthcareCartSlice";
import useBlockBackNavigation from "../hooks/useBlockBackNavigation";
import Navbar from "../components/Navbar";
import OrderConfirmation from "../components/Order/OrderConfirmation";

const HealthcareOrderScreen = () => {
  const user = useSelector((state) => state.user.currentUser);
  const userId = user?.result?._id || user?._id;

  // Access the order from healthcareOrder state
  const { order } = useSelector((state) => state.healthcareOrder);


  // Show the total the server actually charged for THIS order (authoritative
  // distance-based fee/total on the created order) — the legacy flat
  // `/shippingCost` slice is only a fallback for very old order shapes.

  const dispatch = useDispatch();
  const history = useHistory();

  // Back must not return into the checkout flow (double-order protection).
  useBlockBackNavigation("/");

  const handleContinueShopping = () => {
    if (order?.orderItems?.[0]?.vendorId) {
      dispatch(clearCart(order.orderItems[0].vendorId));
    }
    dispatch(resetHealthcareOrder());
    dispatch(resetShippingCost());
    setTrackOrder({});
    history.push("/");
  };


  // Active Step

  // getStepContent

  const [trackOrder, setTrackOrder] = useState({});
  const orderId = order?._id;

  // ── Live order tracking over Socket.IO (same pattern as CODOrderScreen /
  // MyProfile / OrderDetail): join `orderRoom:${client_id}`; the backend Mongo
  // change stream emits `orderUpdate` (full order doc) on every order write;
  // act ONLY on updates for THIS order. Replaces the legacy
  // `/mobile/:userId/stream` SSE, which re-sent a stale snapshot of the
  // customer's LATEST order every 10 s (never re-queried the DB).
  useEffect(() => {
    if (!userId || !orderId) return;

    // Carries the customer's token: their rooms need it (utils/userSocket.js).
    const socket = createUserSocket();

    socket.on("connect", () => {
      console.log("[HealthcareOrder] Socket connected, joining order room…");
      socket.emit("join", `orderRoom:${userId}`);
    });

    socket.on("orderUpdate", (updatedOrder) => {
      if (String(updatedOrder?._id) !== String(orderId)) return;
      console.log(
        "[HealthcareOrder] orderUpdate:",
        updatedOrder?._id,
        updatedOrder?.delivery_status
      );
      setTrackOrder(updatedOrder);
    });

    return () => {
      socket.off("orderUpdate");
      socket.disconnect();
    };
  }, [userId, orderId]);


  // Redirect if no order data
  useEffect(() => {
    if (!order || !order._id) {
      history.push("/");
    }
  }, [order, history]);

  if (!order || !order._id) {
    return null;
  }

  return (
    <>
      <Navbar />
      <OrderConfirmation
        /* Live socket doc when we have one, else the created order.
           trackOrder starts as {} and is replaced on `orderUpdate`, so
           gate on _id rather than truthiness. */
        order={trackOrder?._id ? trackOrder : order}
        onContinueShopping={handleContinueShopping}
      />
    </>
  );
};

export default HealthcareOrderScreen;
